import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import Accordion from '../../Accordion/Accordion'
import { INavItem } from '../NavItem/NavItem'
import { ILinkComponentProps } from '../Navbar'
import './NavbarMobile.css'

export interface INavbarMobileProps {
  leftItems: INavItem[]
  setShowMobileNavbar: Dispatch<SetStateAction<boolean>>
  LinkComponent: FC<ILinkComponentProps>
}

const NavbarMobile = ({
  leftItems,
  LinkComponent,
  setShowMobileNavbar,
}: INavbarMobileProps) => {
  const [updatedNavItems, setUpdatedNavItems] = useState(leftItems)

  // Modifying sublinks to fit mobile criteria
  // and avoid unnecessary CMS duplications
  useEffect(() => {
    const newItems = updatedNavItems.map((el) => {
      if (el.subLinks) {
        return {
          ...el,
          subLinks: [{ name: el.name, href: el.href }, ...el.subLinks],
        }
      }
      return el
    })
    setUpdatedNavItems(newItems)
  }, [])

  return (
    <div className="NavbarMobile__container" data-testid="navbar-mobile">
      <ul className="NavbarMobile__items">
        {updatedNavItems.map((item, index) => {
          return (
            <li key={item.name} className="NavbarMobile__item">
              {item.subLinks && item.subLinks.length ? (
                <>
                  <Accordion
                    key={`${item.name}-${index}`}
                    itemTitle={item.name}
                    itemContent={
                      <ul className="p-0 flex flex-col">
                        {item.subLinks.map((nestedListItem: INavItem) => (
                          <LinkComponent
                            href={nestedListItem.href}
                            key={nestedListItem.href}
                            addClass="NavbarMobile__subitem"
                            onClick={() => {
                              setShowMobileNavbar(false)
                            }}
                          >
                            {nestedListItem.name}
                          </LinkComponent>
                        ))}
                      </ul>
                    }
                  />
                </>
              ) : (
                <LinkComponent
                  href={item.href}
                  aria-label={item.name}
                  addClass="Navbar__link"
                  onClick={() => {
                    setShowMobileNavbar(false)
                  }}
                >
                  <span className="flex items-center">{item.name}</span>
                </LinkComponent>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default NavbarMobile
